import React, { useEffect, useRef, useCallback, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button } from 'reactstrap';
import "./style.css"
import { buildAutomationChildTestId, resolveAutomationTestId } from '../../../../../components/InputField/testId';

function SignPad({ id, asLabel, value = '', style = {}, onChange = () => { } }) {
    const sigCanvas = useRef(null);
    const fileInputRef = useRef(null);
    const [inputKey, setInputKey] = useState(Date.now());
    const fieldTestId = resolveAutomationTestId(id, "signature");

    const clear = () => {
        if (sigCanvas.current) {
            sigCanvas.current.clear();
            onChange('');
        }
        setInputKey(Date.now());
    };

    const updateCanvas = useCallback(() => {
        if (value && sigCanvas.current && sigCanvas.current.isEmpty()) {
            sigCanvas.current.fromDataURL(value);
        }
    }, [value]);

    useEffect(() => {
        updateCanvas();
    }, [updateCanvas]);

    const handleEnd = () => {
        if (!asLabel && sigCanvas.current && !sigCanvas.current.isEmpty()) {
            const dataUrl = sigCanvas.current.toDataURL('image/png');
            onChange(dataUrl);
        }
    };

    const handleUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                onChange(reader.result);
            };
            reader.readAsDataURL(file);
            clear();
        }
    };

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    return (
        <div className='signPad' data-testid={fieldTestId} style={style}>
            <div className="inner-sign-pad">
                <SignatureCanvas
                    penColor={asLabel ? "transparent" : "black"}
                    ref={sigCanvas}
                    canvasProps={{
                        className: 'sigCanvas canvas',
                        'data-testid': buildAutomationChildTestId(fieldTestId, 'canvas'),
                        backgroundColor: '#FFF',
                        width: 340, 
                        height: 200,
                    }}
                    onEnd={handleEnd}
                />
            </div>
            {!asLabel && (
                <>
                    <div className='d-flex mt-3'>
                        <input
                            key={inputKey}
                            ref={fileInputRef}
                            type="file"
                            id={id ? `${id}--upload` : "uploadSign"}
                            data-testid={buildAutomationChildTestId(fieldTestId, 'upload')}
                            accept="image/*"
                            onChange={handleUpload}
                            style={{ display: 'none' }}
                        />
                        <Button className=" mt-0 font-size-14 py-1" data-testid={buildAutomationChildTestId(fieldTestId, 'upload-button')} onClick={triggerFileInput}>
                            Upload Signature
                        </Button>

                        <Button outline className="ms-2 mt-0 font-size-14 py-1" data-testid={buildAutomationChildTestId(fieldTestId, 'clear')} onClick={clear}>
                            Clear
                        </Button>
                    </div>
                </>
            )}
        </div>
    );
}

export default SignPad;
